import './style.scss'

interface IProps {
  orderNo: string
}

export default function FeedBack(props: IProps) {
  const { orderNo = '' } = props
  const onClick = () => {
    window.location.href =
      process.env.REACT_APP_SECRET_CODE === 'production'
        ? `https://inall.ijianshui.com/report?orderNo=${orderNo}`
        : `http://test-inall.ijianshui.com/report?orderNo=${orderNo}`
  }

  return (
    <div className="com-feedback" onClick={onClick}>
      <div className="icon" />
      <div className="t">客服</div>
    </div>
  )
}
